export const ItemTypes = {
  CARD: 'card1',
};
